import { useQueryClient } from 'react-query';

import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteDictionaryItem = () => {
  const queryClient = useQueryClient();
  return useDelete({
    url: ApiRoutesEnum.dictionaryDeleteItem,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) => typeof query.queryKey[0] === 'string' && query.queryKey[0].includes('/dictionaries'),
      });
    },
  });
};
